import { render, staticRenderFns } from "./Escort.vue?vue&type=template&id=b510afe4&scoped=true&"
import script from "./Escort.vue?vue&type=script&lang=js&"
export * from "./Escort.vue?vue&type=script&lang=js&"
import style0 from "./Escort.vue?vue&type=style&index=0&id=b510afe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510afe4",
  null
  
)

export default component.exports